import { QueryObject } from 'bernie-core';
import { parse, parseISO } from 'date-fns';
import { ActivityDateRangeInput, DateInput } from '../common/__generated__/api';
import { DetailQueryObject, SearchQueryObject } from '../stores';
import {
  addDays,
  fromJSDateToISODateString,
  getDateObjectFromDateString,
  getIsoFormatDateFromDateString,
  getTodayDateBexFormat,
  isValidDate,
  isValidDateString
} from './date-helper';

type ActivityDateRange = ActivityDateRangeInput | null;

function areDatesEmpty(query: QueryObject): boolean {
  return !query || (!query.startDate && !query.endDate);
}

function isDateValid(query: QueryObject, date: string, localDateFormat: string): boolean {
  let isValid = true;
  if (query[date]) {
    isValid = isValidDateString(query[date], localDateFormat);
  }

  return isValid;
}

function areDatesInvalid(query: QueryObject, localDateFormat: string): boolean {
  return !(isDateValid(query, 'startDate', localDateFormat) && isDateValid(query, 'endDate', localDateFormat));
}

function populateMissingDateIfAny(
  criteriaQuery: DetailQueryObject | SearchQueryObject,
  localDateFormat: string
): DetailQueryObject | SearchQueryObject {
  if (criteriaQuery) {
    if (!criteriaQuery.startDate) {
      criteriaQuery = {
        ...criteriaQuery,
        startDate: criteriaQuery.endDate
      };
    } else if (!criteriaQuery.endDate) {
      const defaultEndDate = addDays(getDateObjectFromDateString(criteriaQuery.startDate, localDateFormat), 0);

      criteriaQuery = {
        ...criteriaQuery,
        endDate: isValidDate(defaultEndDate) ? fromJSDateToISODateString(defaultEndDate) : ''
      };
    }
  }

  return criteriaQuery;
}

export function handleInvalidDates(
  query: QueryObject,
  criteriaQuery: DetailQueryObject | SearchQueryObject,
  localDateFormat: string
): DetailQueryObject | SearchQueryObject {
  let criteriaQueryObject = {
    ...criteriaQuery
  };
  if (areDatesInvalid(query, localDateFormat)) {
    criteriaQueryObject = {
      ...criteriaQuery,
      startDate: '',
      endDate: ''
    };
  } else if (!areDatesEmpty(query)) {
    criteriaQueryObject = populateMissingDateIfAny(criteriaQuery, localDateFormat);
  }

  return criteriaQueryObject;
}

export function getDateInput(dateString: string, localDateFormat: string): DateInput {
  const isoDate = new Date(getIsoFormatDateFromDateString(dateString, localDateFormat));
  let date = parse(dateString, localDateFormat, isoDate);

  if (isNaN(date.getDate())) {
    date = parseISO(dateString); // Could be in ISO Format
  }

  if (!isNaN(date.getDate())) {
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear()
    };
  }

  return getTodayDateBexFormat();
}

export function activityDateRangeInput(criteriaQuery: QueryObject, localDateFormat: string): ActivityDateRange | null {
  if (!criteriaQuery) {
    return null;
  }

  const { startDate, endDate } = criteriaQuery;

  if (!startDate || !endDate) {
    return null;
  }

  return {
    startDate: getDateInput(startDate, localDateFormat),
    endDate: getDateInput(endDate, localDateFormat)
  };
}
